import Index from '../site/pages/index';

export default Index;
